import i18next from 'i18next';
import TimeSelectBox from 'components/molecules/time-select-box';
import { DateFormatter } from 'infrastructure/functions';
import BaseTableActions from 'components/atoms/base-table/actions';

import { cohorts } from './cohorts';
import s from './styles.module.scss';

import type { IAdherenceSettingCohortsInactiveDays } from 'infrastructure/interfaces';
import type { IBaseTableColumns } from 'components/atoms/base-table/types';

const prepareVal = (date: string) =>
  DateFormatter({
    date,
  });

interface IProps {
  onEdit: (rec: IAdherenceSettingCohortsInactiveDays) => void;
  onDelete: (rec: IAdherenceSettingCohortsInactiveDays) => void;
}

export const columns = ({
  onEdit,
  onDelete,
}: IProps): IBaseTableColumns<IAdherenceSettingCohortsInactiveDays> => {
  return [
    {
      label: i18next.t('labels.from'),
      key: 'from',
      render: (_, rec) => {
        return (
          <TimeSelectBox readonly plaintext value={prepareVal(rec.from)} />
        );
      },
    },
    {
      label: i18next.t('labels.to'),
      key: 'to',
      render: (_, rec) => {
        return <TimeSelectBox readonly plaintext value={prepareVal(rec.to)} />;
      },
    },
    {
      label: i18next.t('labels.inactiveCohorts'),
      key: 'inactiveAdherenceCohorts',
      width: 750,
      render: (_, rec) => {
        return (
          <ul className={s.list}>
            {rec.inactiveAdherenceCohorts.sort().map((el) => (
              <li key={el}>{`${el} - ${cohorts[el]}`}</li>
            ))}
          </ul>
        );
      },
    },
    {
      label: i18next.t('labels.actions'),
      key: 'actions',
      align: 'center',
      width: '40px',
      render: (_, record) => (
        <BaseTableActions
          onEdit={() => onEdit(record)}
          onDelete={() => onDelete(record)}
        />
      ),
    },
  ];
};
